import { defineComponent as _defineComponent } from 'vue'
import UserInfoDataService from "@/services/SignUpUserInfoDataService";
import ResponseData from "@/types/ResponseData";
import { ref, onMounted, onUpdated, reactive } from "vue";
import Alert from "@/components/scan/parts/Alert.vue";
import Loading from "@/components/home/Loading.vue";
import { useRouter } from "vue-router";
import { useI18n } from "vue3-i18n";
import { store } from "@/store/store";
import Navigation from "@/components/NavigationContainer.vue";
import SendEmailService from "@/services/SendEmailService";


export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {
  expose();

const router = useRouter();
const isLoading = ref(false);
const permissionFlg = reactive([]);
const permissionDetail = reactive([]);
const i18n = useI18n();
const alertMessage = ref("null");
const alertState = ref("neutral");
const userAuthenticationInfo = reactive([]);
const userApplicationInfo = reactive([]);
const userScanInfo = reactive([]);
const employeeID = store.getters.cognitoUserName;
const givenName = store.getters.givenName;
const familyName = store.getters.familyName;
const email = store.getters.email;
const department = store.getters.department;
const title = store.getters.title;
const stationCode = store.getters.stationCode;
const companyName = store.getters.companyName;

onMounted(function () {
  isLoading.value = true;
  if (permissionDetail.length == 0) {
    getPermissionDetailInfo();
  }
});

const backUserInfo = () => {
  isLoading.value = true;
  router.push({
    path: "/AddUser",
  });
};

/** 権限明細情報取得 */
const getPermissionDetailInfo = () => {
  isLoading.value = true;
  //二回目実行にアラートメッセージが表示修正
  alertMessage.value = "null";
  alertState.value = "neutral";

  permissionDetail.splice(0);
  var data = {
    stationCode: store.getters.stationCode,
    department: store.getters.department
  }

  // get Permission Detail Information
  UserInfoDataService.getPermissionDetail(data)
    .then((response: ResponseData) => {
      if (response.data.length != 0) {
        for (let info of response.data) {
          if (stationCode != "1000") {
            if (!info.SMCFlg) {
              permissionDetail.push(info);
            }
          } else {
            // 社内「HQ user」・社外「Dist Admin」のみ表示修正
            if (info.mainMenuCode != "MM0064") {
              permissionDetail.push(info);
            }
          }          
        }
        filterPermissionDetailByMenuStationMapping();
      }
      isLoading.value = false;
    })
    .catch((e: Error) => {
      console.log(e);
      alertMessage.value = i18n.t("err014");
      alertState.value = "error";
      isLoading.value = false;
    });
};

const filterPermissionDetailByMenuStationMapping = () => {
  isLoading.value = true;
  var data = {
    stationCode : store.getters.stationCode,
    department : store.getters.department
  }

  UserInfoDataService.getMenuStationMapping(data)
    .then((response: ResponseData) => {
      const info = response.data;
      const result = permissionDetail.filter((menuInfo: any) => 
        info.some((item: any) => item.mainmenucode === menuInfo.mainMenuCode) &&
        !info.some(
          (item:any)=>
            item.mainmenucode === menuInfo.mainMenuCode &&
            item.stationcode === data.stationCode
        )
      );
      console.log(result);

      for (let i = permissionDetail.length - 1; i >= 0; i--) {
        if (result.some((r: any) => r.mainMenuCode === permissionDetail[i].mainMenuCode)) {
          permissionDetail.splice(i, 1);
        }
      }
    })
    .catch((e:Error) => {
      console.log(e);
      alertMessage.value = i18n.t("err014");
      alertState.value = "error";
      isLoading.value = false;
    });
};

/** チェックボックス押下時の処理関数 */
const chkChange = (param: string) => {
  var chkHeaderID = "chkHeader" + param;
  var isHeaderCheck = true;
  var chkName = "chk" + param;
  var allChk = document.getElementsByName(chkName);
  // サブチェックボックスが【1】行以上ならヘッダチェックに反映する
  if (allChk.length > 1) {
    for (var i = 0; i < allChk.length; i++) {
      if (allChk[i].checked == false) {
        isHeaderCheck = false;
      }
    }
    document.getElementById(chkHeaderID).checked = isHeaderCheck;
  }
};

/** ヘッダチェックボックス変更 */
const chkHeaderChange = (param: string, index: number) => {
  var chkHeaderID = "chkHeader" + param;
  var chkName = "chk" + param;
  var isHeaderCheck = document.getElementById(chkHeaderID).checked;
  var allChk = document.getElementsByName(chkName);
  // 各チェック未チェックの反映
  for (var i = 0; i < allChk.length; i++) {
    allChk[i].checked = isHeaderCheck;
    index++;
  }
};

const insertUserInfo = () => {
  isLoading.value = true;

  //二回目実行にアラートメッセージが表示修正
  alertMessage.value = "null";
  alertState.value = "neutral";

  // 2023/05/18 MDCR 修正 start(同じstationCodeに違うUserIdがあるため、stationCodeの条件追加対応)
  const data = {
    userId: employeeID,
    stationCode: stationCode
  };
  // 2023/05/18 MDCR 修正 end
  userAuthenticationInfo.splice(0);
  userApplicationInfo.splice(0);

  if (stationCode == "1000") {
    UserInfoDataService.getEmployeeIDData(data)
      .then((response: ResponseData) => {
        if (response.data.length != 0) {
          alertMessage.value = i18n.t("err064");
          alertState.value = "error";
          isLoading.value = false;
        } else {
          chkUserInfo();
        }
      })
      .catch((e: Error) => {
        console.log(e);
        alertMessage.value = i18n.t("err020");
        alertState.value = "error";
        isLoading.value = false;
      });
  } else {
    UserInfoDataService.getTmpEmployeeIDData(data)
      .then((response: ResponseData) => {
        if (response.data.length != 0) {
          if (
            response.data[0].employeeNumber == employeeID &&
            response.data[0].stationCode.stationCode == stationCode
          ) {
            alertMessage.value = i18n.t("err064");
            alertState.value = "error";
            isLoading.value = false;
          } else {
            insertTmpInfo();
          }
        } else {
          insertTmpInfo();
        }
      })
      .catch((e: Error) => {
        console.log(e);
        alertMessage.value = i18n.t("err020");
        alertState.value = "error";
        isLoading.value = false;
      });
  }
};

const chkUserInfo = () => {
  //二回目実行にアラートメッセージが表示修正
  alertMessage.value = "null";
  alertState.value = "neutral";
  const data = { userId: employeeID };

  UserInfoDataService.chkApplicationUserID(data)
    .then((response: ResponseData) => {
      if (response.data.length != 0) {
        for (let info2 of response.data) {
          userScanInfo.push(info2);
        }
        //get chk app
        UserInfoDataService.getChkApp(data).then((response1: ResponseData) => {
          // 2023/05/12 MDCR 修正 start
          // if (userScanInfo[0].app == response1.data.chkApp) {
          var arrScanInfo = userScanInfo[0].app.split(';');
          if (arrScanInfo.includes(response1.data.chkApp)) {
            // 2023/05/12 MDCR 修正 end
            alertMessage.value = i18n.t("err060");
            alertState.value = "error";
            isLoading.value = false;
          } else if(!userScanInfo[0].email.toLowerCase().match(email.toLowerCase())) {
            alertMessage.value = i18n.t("err097");
            alertState.value = "error";
            isLoading.value = false;
          } else {
            const cscfileData1 = {
              actionFlg: 5,
              userID: employeeID,
              LName: familyName,
              FName: givenName,
              employeeID: employeeID,
              mail: email,
              companyName: companyName,
              stationCode: stationCode,
            };
            UserInfoDataService.send_authenticationID(cscfileData1)
              .then(() => {
                insertInfo();
              })
              .catch((e: Error) => {
                alertMessage.value = i18n.t("err063");
                alertState.value = "error";
                isLoading.value = false;
                console.log(e);
              });
          }
        });
      } else {
        const cscfileData2 = {
          actionFlg: 1,
          userID: employeeID,
          LName: familyName,
          FName: givenName,
          employeeID: employeeID,
          mail: email,
          companyName: companyName,
          stationCode: stationCode,
        };
        UserInfoDataService.send_authenticationID(cscfileData2)
          .then(() => {
            insertInfo();
          })
          .catch((e: Error) => {
            alertMessage.value = i18n.t("err063");
            alertState.value = "error";
            isLoading.value = false;
            console.log(e);
          });
      }
    })
    .catch((e: Error) => {
      alertMessage.value = i18n.t("err061");
      alertState.value = "error";
      isLoading.value = false;
      console.log(e);
    });
};

const insertInfo = () => {
  permissionFlg.splice(0);
  //二回目実行にアラートメッセージが表示修正
  alertMessage.value = "null";
  alertState.value = "neutral";

  var permissiontbl = document.getElementById("permissiontbl");
  const totalMenu = permissiontbl.rows.length;
  var checkboxList = document.getElementsByName("chkHeader");
  const titleLen = checkboxList.length;

  for (let i = 0; i < totalMenu - titleLen; i++) {
    const chkFlg = document.getElementById("chk" + i);
    if (chkFlg.checked == true) {
      permissionFlg.push(permissionDetail[i].mainMenuCode);
    }
  }

  const userinfoData = {
    userId: employeeID,
    givenName: givenName,
    familyName: familyName,
    email: email,
    department: department,
    title: title,
    stationCode: stationCode,
    mainMenuCode: permissionFlg,
  };
  UserInfoDataService.insertUserInfo(userinfoData)
    .then(() => {
      // SMC管理者へメール送信
      const menuData = {
        userId: userinfoData.userId,
        menuList: userinfoData.mainMenuCode
      };
      SendEmailService.sendEmailByMenu(menuData)
        .then((response2: ResponseData) => {
          if (response2.data.length != 0) {
            for (var i = 0; i < response2.data.length; i++) {
              const smcData = {
                userId: userinfoData.userId,
                targetMailFormat: "mail_SMC_manager_notice",
                sendingPattern: "SMC_manager_notice",
                email: response2.data[i]['email'],
                menuList: response2.data[i]['menuList'],
                loginUserId: store.getters.cognitoUserName
              };
              SendEmailService.sendEmail(smcData).then(() => {
                isLoading.value = false;
                router.push({ path: "/UserCreation" });
              })
                .catch((e: Error) => {
                  alertMessage.value = "Fail to send notice email of permission approval";
                  alertState.value = "error";
                  isLoading.value = false;
                  console.log(e);
                });
            }
          } else {
            isLoading.value = false;
            router.push({ path: "/UserCreation" });
          }
        })
        .catch((e: Error) => {
          alertMessage.value = "Fail to send notice email of permission approval";
          alertState.value = "error";
          isLoading.value = false;
          console.log(e);
        });
    })
    .catch((e: Error) => {
      alertMessage.value = i18n.t("err016");
      alertState.value = "error";
      isLoading.value = false;
      console.log(e);
    });
};

const insertTmpInfo = () => {
  permissionFlg.splice(0);
  //二回目実行にアラートメッセージが表示修正
  alertMessage.value = "null";
  alertState.value = "neutral";

  var permissiontbl = document.getElementById("permissiontbl");
  const totalMenu = permissiontbl.rows.length;
  var checkboxList = document.getElementsByName("chkHeader");
  const titleLen = checkboxList.length;

  for (let i = 0; i < totalMenu - titleLen; i++) {
    const chkFlg = document.getElementById("chk" + i);
    if (chkFlg.checked == true) {
      permissionFlg.push(permissionDetail[i].mainMenuCode);
    }
  }

  const userinfoData = {
    userId: employeeID,
    givenName: givenName,
    familyName: familyName,
    email: email,
    department: department,
    title: title,
    stationCode: stationCode,
    mainMenuCode: permissionFlg,
  };

  UserInfoDataService.insertTmpUserInfo(userinfoData)
    .then(() => {
      // 2023/05/17 MDCR 修正 start
      const data = {
        userId: employeeID,
        stationCode: stationCode,
        targetMailFormat: "mail_node_manager_notice",
        sendingPattern: "kyoten_notice",
        loginUserId: store.getters.cognitoUserName
      };
      SendEmailService.sendEmail(data)
        .then(() => {
          router.push({ path: "/UserCreation" });
        })
        .catch((e: Error) => {
          alertMessage.value = "Fail to send notice email of user approval";
          alertState.value = "error";
          isLoading.value = false;
          console.log(e);
        });
      // 2023/05/17 MDCR 修正 end
    })
    .catch((e: Error) => {
      alertMessage.value = i18n.t("err016");
      alertState.value = "error";
      isLoading.value = false;
      console.log(e);
    });
};

onUpdated(function () {
  try {
    var dataHeight = document.getElementById("permissiontbl")?.clientHeight;
    if (dataHeight != 0) {
      var divHeight = document.getElementById("divPermitList")?.clientHeight;
      if (divHeight > dataHeight) {
        document.getElementById("permissiontbl1").style.width = "90%";
      } else {
        document.getElementById("permissiontbl1").style.width = "calc(90% - 16px)";
      }
    }
  } catch (e) {
    isLoading.value = false;
  }

});

const __returned__ = { router, isLoading, permissionFlg, permissionDetail, i18n, alertMessage, alertState, userAuthenticationInfo, userApplicationInfo, userScanInfo, employeeID, givenName, familyName, email, department, title, stationCode, companyName, backUserInfo, getPermissionDetailInfo, filterPermissionDetailByMenuStationMapping, chkChange, chkHeaderChange, insertUserInfo, chkUserInfo, insertInfo, insertTmpInfo, Alert, Loading, Navigation }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})